import { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";
import styles from "./backtottop.module.css";
const BackToTop = () => {
  const [show, setShow] = useState(false);
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      const scrollPercent = (scrollTop / docHeight) * 100;
      setProgress(scrollPercent);
      setShow(scrollTop > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    show && (
    <button
  className={styles.backToTop}
  style={{
    background: `conic-gradient(
      var(--color-text-green) ${progress}%,
      #e5e5e5 ${progress}%
    )`,
  }}
  onClick={scrollToTop}
  aria-label="Back to top"
>
  <span className={styles.icon}>
    <FaArrowUp />
  </span>
</button>
    )
  );
};
export default BackToTop;